module.exports = __webpack_public_path__ + "img/logo_1.e90b9f25.svg";